import qs from "qs";
import { ILateCharge } from "../../types/LateCharges";
import authAxios, { authHeader } from "../data";

const fetch = async (id: string) => {
  const response = await authAxios.get("/api/AdministrateLateCharges/" + id, {
    headers: authHeader(),
  });

  return response.data;
};

const fetchAll = async (req: any) => {
  const response = await authAxios.get("/api/AdministrateLateCharges", {
    params: req,
    paramsSerializer: (params) => qs.stringify(params),
    headers: authHeader(),
  });

  return response.data;
};

const fetchCount = async (req: any) => {
  const response = await authAxios.get("/api/AdministrateLateCharges/Count", {
    headers: authHeader(),
  });

  return response.data;
};

const create = async (req: ILateCharge) => {
  const response = await authAxios.post("/api/AdministrateLateCharges", req, {
    headers: authHeader(),
  });

  return response.data;
};

const edit = async (req: ILateCharge, id: string) => {
  const response = await authAxios.put(
    "/api/AdministrateLateCharges/" + id,
    req,
    {
      headers: authHeader(),
    }
  );

  return response.data;
};

const remove = async (id: string) => {
  const response = await authAxios.delete(
    "/api/AdministrateLateCharges/" + id,
    {
      headers: authHeader(),
    }
  );

  return response.data;
};

const fetchLateChargesCalc = async () => {
  const response = await authAxios.get("/api/Servicer/", {
    headers: authHeader(),
  });

  return response.data;
};

const editLateChargeCalc = async (req: any) => {
  const response = await authAxios.put("/api/Servicer/lateCharge", req, {
    headers: authHeader(),
  });

  return response.data;
};

const LateChargesService = {
  fetch,
  fetchAll,
  fetchCount,
  create,
  edit,
  remove,
  fetchLateChargesCalc,
  editLateChargeCalc,
};

export default LateChargesService;
